import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
const steps = [{
  num: '01',
  title: 'Auditoría',
  desc: "Identificás las tareas 'bobas' que te están robando la vida."
}, {
  num: '02',
  title: 'Implementación',
  desc: 'Conectás tus herramientas de cobro y atención usando nuestros flujos probados.'
}, {
  num: '03',
  title: 'Escala',
  desc: 'Liberás 15-20 horas semanales para enfocarte únicamente en lo que trae más dinero.'
}];
export function ProcessSection() {
  return <Section className="px-6 md:px-12 max-w-5xl mx-auto" data-id="element-186">
      <div className="text-center mb-16 md:mb-24" data-id="element-187">
        <h2 className="font-serif text-3xl md:text-4xl font-semibold text-[#f0c674]" data-id="element-188">
          Cómo funciona
        </h2>
      </div>

      <div className="relative" data-id="element-189">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-0 w-full h-[1px] bg-gray-800 z-0" data-id="element-190" />

        <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-191">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.6
        }} className="flex flex-col items-center text-center md:items-start md:text-left" data-id="element-192">
              <div className="w-24 h-24 rounded-full bg-[#0a0a0a] border border-[#d4a853]/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(212,168,83,0.05)]" data-id="element-193">
                <span className="font-mono text-3xl text-[#d4a853]" data-id="element-194">
                  {step.num}
                </span>
              </div>
              <h3 className="font-serif text-2xl text-gray-100 mb-4" data-id="element-195">
                {step.title}
              </h3>
              <p className="font-sans text-gray-400 leading-relaxed" data-id="element-196">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}